import React, { useEffect, useState } from "react";
import { message, Input, Modal } from "antd";

const emptyContact = {
	name: "",
	phone: "",
	email: "",
};

import PropTypes from "prop-types";

const inModeEdit = (contactDataToEdit) => {
	return JSON.stringify(contactDataToEdit) !== JSON.stringify(emptyContact);
};

export const ContactModal = ({
	title = "Sin titulo", 
	contacts, 
	openModal, 
	setOpenModal, 
	onNewContact, 
	contactDataToEdit = emptyContact 
}) => {
	const [contact, setContact] = useState(contactDataToEdit);

	useEffect(() => {
		if(!openModal) return;
				
		if(!inModeEdit(contactDataToEdit)) return;
		
		setContact(contactDataToEdit);
	}, [openModal]);

	const makeChanges = () => {
		const emptyValues = Object.keys(contact).filter((name) => contact[name].trim() === "");
				
		if(emptyValues.length > 0){
			message.error(`Porfavor llena ${JSON.stringify(emptyValues)}`);
			return;
		}
		
		const contactsToCheck = inModeEdit(contactDataToEdit) ? 
			contacts.filter((contact) => contact.name !== contactDataToEdit.name): // Avoid ContactDataToEdit
			contacts; // Normal Data of Contacts
		
		const rulesDone = checkContactRules(contactsToCheck);
		if(!rulesDone) return;
			
		onNewContact(contact);                
		setContact(emptyContact);
		setOpenModal(false);
	};

	const checkContactRules = (contactsToCheck) => {
		const isDuplicated = contactsToCheck.some((existingContact) =>
			existingContact.name.trim() === contact.name.trim() &&
			existingContact.phone.trim() === contact.phone.trim() &&
			existingContact.email.trim() === contact.email.trim()
		);

		if(isDuplicated) {
			message.error("Porfavor ingresa valores unicos, no repita la misma data");
			return false;
		}

		const nameDuplicated = contactsToCheck.some((existingContact) =>
			existingContact.name.trim().toLowerCase() === contact.name.trim().toLowerCase()
		);

		if(nameDuplicated){
			message.error("Nombre duplicado, porfavor cambia el nombre");
			return false;
		}

		return true;
	};
		
	return (
		<Modal
			title={title}
			open={openModal}				
			onOk={makeChanges}
			onCancel={() => {
				setContact(emptyContact);
				setOpenModal(false);
			}}
		>
			<h3>Nombre:</h3>
			<Input 
				placeholder="Ingresa Nombre..." 
				value={contact.name}
				onChange={(e) => setContact({...contact, name: e.target.value})}
				status={contact.name.trim() === "" ? "error" : "success"}
			/>				
			<h3>Telefono:</h3>
			<Input 
				placeholder="Ingresa Telefono..." 
				value={contact.phone}
				onChange={(e) => setContact({...contact, phone: e.target.value})} 
				status={contact.phone.trim() === "" ? "error" : "success"}
			/>
			<h3>Correo:</h3>
			<Input 
				placeholder="Ingresa Correo..." 
				value={contact.email}
				onChange={(e) => setContact({...contact, email: e.target.value})} 
				status={contact.email.trim() === "" ? "error" : "success"}
			/>
		</Modal>
	);
};

ContactModal.propTypes = {
	title: PropTypes.string,
	openModal: PropTypes.bool.isRequired,
	setOpenModal: PropTypes.func.isRequired,
	contacts: PropTypes.array.isRequired,	
	onNewContact: PropTypes.func.isRequired,
	contactDataToEdit: PropTypes.shape({
		name: PropTypes.string.isRequired,
		phone: PropTypes.string.isRequired,
		email: PropTypes.string.isRequired,
	})
};